export default __webpack_public_path__ + "static/media/logo2.1d208899.png";